'use strict';

angular.module('casist.widgets', [
  'ui.bootstrap',
  'casist.widgets.notification',
  'ui.select2',
  'angular-sortable-view',
]);
